import { render, staticRenderFns } from "./DialogPortal.vue?vue&type=template&id=315c992f&lang=pug&"
import script from "./DialogPortal.vue?vue&type=script&lang=js&"
export * from "./DialogPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports